import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const GeographicDistribution = ({ locations }) => {
  const maxValue = Math.max(...locations?.map(l => l?.submissions));

  return (
    <div className="bg-card border border-border rounded-md p-4 md:p-6 shadow-elevation-sm">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-heading font-semibold text-foreground">
          Geographic Distribution
        </h3>
      </div>

      <div className="space-y-3">
        {locations?.map((location) => {
          const percentage = (location?.submissions / maxValue) * 100;
          
          return (
            <div key={location?.country} className="space-y-2">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <span className="text-2xl">{location?.flag}</span>
                  <span className="text-sm font-medium text-foreground">
                    {location?.country}
                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <span className="text-sm text-muted-foreground">
                    {location?.submissions} submissions
                  </span>
                  <span className="text-sm font-semibold text-foreground">
                    {location?.percentage}%
                  </span>
                </div>
              </div>
              <div className="relative h-2 bg-muted rounded-full overflow-hidden">
                <div
                  className="absolute inset-y-0 left-0 bg-primary rounded-full transition-smooth"
                  style={{ width: `${percentage}%` }}
                />
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-6 p-4 bg-muted rounded-md">
        <div className="flex items-center gap-2 text-sm text-muted-foreground mb-2">
          <Icon name="Globe" size={16} />
          <span>Total Countries: {locations?.length}</span>
        </div>
        <p className="text-xs text-muted-foreground">
          Data collected from IP geolocation and browser settings
        </p>
      </div>
    </div>
  );
};

export default GeographicDistribution;